module.exports = __webpack_public_path__ + "static/img/Yummy-Recipe.a5c0378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miximo/imgs/browse/Yummy-Recipe.jpg
// module id = 1766
// module chunks = 0